module.exports = __webpack_public_path__ + "static/media/final-04.b52bc2e6.svg";